import React from "react";
import { reduxForm } from "redux-form";

import { Form } from "../form";

/*

Simple wrapper which allows to display error e.g. in confirmation modal without setting it in local state.

Example:

const Send = SendForm('some-unique-id');

<Send onSubmit={() => promiseAction()
    .then(() => {
        Snackbar.success('Successful');
        ConfirmationModal.close();
    })
    .catch((error) => {
        throw new SubmissionError(error);
    })}>
    {(submit) =>
        <ModalConfirm
            onConfirm={submit}
            onCancel={ConfirmationModal.close}>
            {content}
        </ModalConfirm>}
</Send>

 */

type SendFormProps = {
  children: (submit: () => void) => React.ReactNode;
};
export const SendForm = <TForm extends object>(formId: string) =>
  reduxForm<TForm, SendFormProps>({ form: formId })(
    ({ children, submit, error }) => {
      return (
        <Form onSubmit={submit} error={error}>
          {children(submit)}
        </Form>
      );
    },
  );
